export default {
  'userandregister-result.login.userName': 'userName',
  'userandregister-result.login.password': 'password',
  'userandregister-result.login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'userandregister-result.login.message-invalid-verification-code': 'Invalid verification code',
  'userandregister-result.login.tab-login-credentials': 'Credentials',
  'userandregister-result.login.tab-login-mobile': 'Mobile number',
  'userandregister-result.login.remember-me': 'Remember me',
  'userandregister-result.login.forgot-password': 'Forgot your password?',
  'userandregister-result.login.sign-in-with': 'Sign in with',
  'userandregister-result.login.signup': 'Sign up',
  'userandregister-result.login.login': 'Login',
  'userandregister-result.register.register': 'Register',
  'userandregister-result.register.get-verification-code': 'Get code',
  'userandregister-result.register.sign-in': 'Already have an account?',
  'userandregister-result.register-result.msg': 'Account：registered at {email}',
  'userandregister-result.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'userandregister-result.register-result.back-home': 'Back to home',
  'userandregister-result.register-result.view-mailbox': 'View mailbox',
  'userandregister-result.navBar.lang': 'Languages',
};
